
  import { defineComponent, PropType } from 'vue';

  export default defineComponent({
    name: 'DashboardsCardsWrapper',
    props: {
      items: {
        type: Array as PropType<any[]>,
        default: () => [],
      },
      itemKey: {
        type: String,
        default: 'id',
      },
      columns: {
        type: Number,
        default: 4,
      },
    },
  });
